import React, { useMemo } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  type ChartOptions,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function IdentifiedRisk({riskIdentified}:any) {
  const stackedData = useMemo(
      () => ({
        labels: ["HCPs", "Patients", "Caregivers"],
        datasets: [
          {
            label: "Value",
            data: [40, 66, 100],
            backgroundColor: "#9ADC54",
            borderRadius: 14,
          },
          {
            label: "Readiness",
            data: [40, 33, 0],
            backgroundColor: "#3d5f1f",
            borderRadius: 14,
          },
          {
            label: "Enthusiasm",
            data: [20, 0, 0],
            backgroundColor: "#87C8FF",
            borderRadius: 14,
          },
        ],
      }),
      []
    );
  
    const stackedOptions: ChartOptions<"bar"> = {
      responsive: true,
      maintainAspectRatio: false,
  
      animation: {
        duration: 1200,
        easing: "easeOutQuart",
      },
  
      plugins: {
        legend: {
          position: "top",
          labels: {
            usePointStyle: true,
            pointStyle: "circle",
            padding: 20,
          },
        },
        tooltip: {
          enabled: true,
        },
      },
  
      scales: {
        x: {
          stacked: true,
          grid: { display: false },
          ticks: {
            font: { size: 14 },
          },
        },
        y: {
          stacked: true,
          min: 0,
          max: 100,
          ticks: { stepSize: 20 },
        },
      },
    };

    const formatKey = (key: string) => {
      const keyMap: Record<string, string> = {
        clinical_risks: "Clinical Risks",
        communication_risks: "Communication Risks",
        mitigation_guardrails: "Mitigation & Guardrails",
      };
      return keyMap[key] || key;
    };

  return (
    <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-2 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">
        Identified Risks
      </h1>

     
        {/* <div className="flex flex-col items-center">
        <h4 className="text-black font-semibold text-xl max-w-4xl text-center">
            AI Adoption Levels
        </h4>

        <div className="w-[400px] h-full p-2">
            <Bar data={stackedData} options={stackedOptions} />
        </div>
                
        </div> */}
     <div className="grid grid-cols-1 gap-2 lg:grid-cols-3">
      {Object.entries(riskIdentified || {}).map(([key, items]:any) => (
        <div
          key={key}
          className="bg-[#9ADC54] border border-[#FFF7CE] rounded-md p-2"
        >
          <ul>
            <li>
              <strong className="text-lg">{formatKey(key)}</strong>
              <ul className="list-inside pl-1 flex flex-col gap-1">
                <li>
                  <ul className="list-disc pl-3">
                    {items.map((item: string, index: number) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      ))}
    </div>
     
    </div>
  );
}
